import React, { useEffect, useState,useContext } from "react";
import "./Profilepop.css";
import common from "../config/common.json"
import getGlobalVarContext from "../context/getGlobalVarContext";
import {useIntl} from 'react-intl';

// import Accountpopup from "./Accountpopup";


function YourCurrentPlan(plan) {
  var requestOptions = {
    method: "GET"
  };
  const [state1, setState1] = useState({});
  const { globalVar} = useContext(getGlobalVarContext());
  const {email}= globalVar
  const intl = useIntl()
  useEffect(() => {
    fetch(
      `${common.BASEURL}/user/details?email=${email !==null ?email:localStorage.getItem("email")}`,
      requestOptions
    )
      .then(response => response.json())
      .then(result => {
        var list = [];
        list.push(result.msg);
        setState1(result.msg);
      })
      .catch(error => console.log("error", error));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="profilepop current_plan">
      <div className="profilepop_form curent_pla_left">
        <h3>{intl.formatMessage({id: "currentPage" })}</h3>
        <button className="profilepop_button Your_Current_plan_button">
          {state1?.plan}
        </button>
        <h5 className="Your_Current_plan_textcenter">
        {intl.formatMessage({id: "currentPaymentInfo" })}
          <br />
          {intl.formatMessage({id: "currentPaymentInfo1" })}
        </h5>
        <div className="withextra">
          <div className="leftbill">
            <label>{intl.formatMessage({id: "currentPaymentLableAccount" })}</label>
            <h5 className="htag" style={{paddingBottom:"10px",paddingTop:"5px"}}> {state1.email}</h5>
            <label style={{marginTop:"5px",marginBottom:"5px"}}>{intl.formatMessage({id: "currentPaymentLableBillingAddress" })}</label>
           
            
              <div className="billinguserdata" style={{display:"flex",color:"var(--primary-color)",marginTop:"5px",marginBottom:"5px",width:"100%"}}>
              <div className="colorgray" style={{width:"50%"}}>
                <p>{intl.formatMessage({id: "currentPaymentLableFirstName" })} {state1.first_name} </p>
              </div>
              <div>
                <div  className="colorgray" style={{marginRight:"20px"}}>
                  <p>{intl.formatMessage({id: "currentPaymentLastName" })} {state1.last_name} </p>
                </div>
              </div>
            </div>

            <div className="billinguserdata" style={{display:"flex",color:"var(--primary-color)",marginTop:"5px",marginBottom:"5px"}}>
            <div  className="colorgray" style={{width:"50%"}}>
              <p>{intl.formatMessage({id: "currentPaymentLableCity" })} {state1.city} </p>
            </div>
            <div>
              <div  className="colorgray" style={{marginRight:"20px"}}>
                <p>{intl.formatMessage({id: "currentPaymentLableState" })} {state1.state} </p>
              </div>
            </div>
          </div>
          <div className="billinguserdata" style={{display:"flex",color:"var(--primary-color)",marginTop:"5px",marginBottom:"5px"}}>
            <div  className="colorgray" style={{width:"50%"}}>
              <p>{intl.formatMessage({id: "currentPaymentLableZip" })} {state1.zip} </p>
            </div>
            <div>
              <div  className="colorgray" style={{marginRight:"20px"}}>
                <p>{intl.formatMessage({id: "currentPaymentLableCountryCode" })} {state1.country} </p>
              </div>
            </div>
          </div>
            <p style={{color:"gray"}}>{intl.formatMessage({id: "currentPaymentLableFullAddress" })} {state1.line1} </p>
          </div>
        </div>
        
      </div>
    </div>
  );
}
export default YourCurrentPlan;
